module.exports = __webpack_public_path__ + "static/img/chaoshi.08a2940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chaoshi.png
// module id = cPb/
// module chunks = 21